module.exports = [{
        name: "Organização do Lucas",
        since: "1993",
        link: "/ong-ficha",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização do Matheus",
        since: "1998",
        link: "/doador-ficha",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização do Antonio",
        since: "1966",
        link: "/",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização da Sueli",
        since: "1966",
        link: "/",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização do Vô Leandro",
        since: "1935",
        link: "/",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização do Lucas",
        since: "1993",
        link: "/",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização do Lucas",
        since: "1993",
        link: "/",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização do Lucas",
        since: "1993",
        link: "/",
        logo: "/images/icons/company_placeholder.jpg"
    },
    {
        name: "Organização do Lucas",
        since: "1993",
        link: "/",
        logo: "/images/icons/company_placeholder.jpg"
    }
]
